<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
  <div class="col">
    <div class="eventsheader">Favorites</div>
  </div>

</div>

<body style="background-color: rgb(241, 235, 228);">
<div class="w-90 p-3 fulldiv">
    <div class="row">
      <div class="col-sm-9" style="background-color:rgb(241, 235, 228);">
        <div class="emptyfavoritesdiv" *ngIf="events.length == 0">
          <p class="nofavorites"><span class="material-icons ">sentiment_very_dissatisfied</span></p>
          <p class="nofavorites">You don't have any events added to favorites</p>
          <p class="nofavorites">You can <a href="/main"><strong>browse</strong></a> all events and add them to your favorites.</p>
          <p class="nofavorites">Here's a list of our recommended events</p>
        </div>
        <div class="eventdiv" *ngFor="let item of events">
          <p (click)="goToEventPage(item)" class="eventtitle">{{item.event_name}}</p>
          <div class="container">
            <div class="row">
              <div class="col-sm">
                <i (click)="unfavorite(item.id)" class="material-icons faviconyellow">favorite</i>
                <img (click)="goToEventPage(item)" class="eventimg"
                  src="{{'https://events.globalistic.tech/'+item.images[0].filename}}">
              </div>
              <div class="col-sm">
                <ul class="fa-ul">
                  <li>
                    <span class="fa-li">
                     <i class="fa fa-map-marker"></i>
                    </span>
                    <label class="location">
                      {{item.location}}
                    </label>
                  </li>
                 
                  <li *ngIf="item.passedEvent"><span class="fa-li"><i class="fa fa-clock-o"></i></span>This event has passed</li>
                 
                  <li *ngIf="!item.passedEvent"><span class="fa-li"><i class="fa fa-clock-o"></i></span>{{item.firstDate | date: 'MMM dd,yyyy'}} - {{item.lastDate | date: 'MMM dd,yyyy'}} from {{item.event_dates[0].start_time }} until {{item.event_dates[0].end_time}}</li>

            
                  <li *ngIf="item.noWebsite" (click)="navigate(item.website)" target="_blank"><span class="fa-li"><i class="fa fa-link"></i></span>{{item.website}}</li>
                  <!-- <li><span class="fa-li"><i class="fa fa-money"></i></span>{{item.min_fee == item.max_fee ? item.min_fee+"$" : "BETWEEN" + item.min_fee + "$ AND " + item.max_fee +"$" }}</li> -->
                  <!-- <li><span class="fa-li"><i class="fa fa-eye"></i></span>{{item.visit == null ? 0 : item.visit}}</li> -->
                  <!-- <li><span class="fa-li"><i class="fa fa-list"></i></span>{{item.category}}</li> -->
                </ul>
              </div>
              <!-- <div [class.collapsed]="item.collapsed" style="margin-left: 10px;" class="col-sm">
                <p class="eventdescription" [class.show]="item.showMore">{{item.description}}</p>
                <p class="readmore" (click)="item.showMore = !item.showMore">{{ item.showMore ? 'Read Less': 'Read More' }}</p>
              </div> -->
              <div class="col-sm">
              <div [innerHTML]="item.description" [ngClass]="{ 'isCollapsed': !item.isCollapsed &&item.isReadMore , 'collapsed': item.isCollapsed&&item.isReadMore }" style="margin-left: 10px;">
              </div>
                <span [hidden]="!item.isReadMore">
                  <span (click)="item.isCollapsed = !item.isCollapsed" class="readmore" style="float: right;" *ngIf="item.isCollapsed"><i>Read More...</i></span>
                  <span (click)="item.isCollapsed = !item.isCollapsed" class="readmore" *ngIf="!item.isCollapsed"><i>Read Less</i></span>
                </span>
          </div>

            <!-- <div>{{item.description}}</div> -->

            <!-- <div class='cb'></div> -->
            </div>
          </div>
        </div>      
      </div>
        <div style="text-align: center;" *ngIf="emptyAdmin && emptyUser" class="col-sm-3 col-md-6 col-lg-4">
          No Ads
        </div>
        <div *ngIf="true" class="col-sm-3">
          <div class="column">
            <div style="font-weight: bold; margin-top:30px">Advertisement</div>
            <div (click)="navigate(adminAd.url)" class="sidecard ad">
              <img class="cardimg" src="{{'https://events.globalistic.tech/'+ adminAd.image}}" />
              <div class="sidecard-content ">
                <div class="title">{{adminAd.name}}</div>
                <div class="sub_title">{{adminAd.description}}</div>
                <div (click)="navigate(adminAd.url)" class="description">{{adminAd.url}}</div>
              </div>
            </div>
    

            <div class="sidecard ad">
              <img class="cardimg" src="{{'https://events.globalistic.tech/'+ userAd.image}}" />
              <div class="sidecard-content ">
                <div class="title">{{userAd.name}}</div>
                <div class="sub_title">{{userAd.description}}</div>
                <div  (click)="navigate(userAd.link)" class="description">{{userAd.link}}</div>
              </div>
            </div>
    
          </div>
        </div>

    </div>
</div>
